import { alpha } from '@mui/material';

const styles = {
  card: {
    height: '100%',
    backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.1),
  },
  pieMargin: {
    right: 150,
  },
  pieSlot: {
    legend: {
      labelStyle: {
        fontSize: 12,
      },
    },
  },
  lineMargin: {
    left: 120,
  },
  lineSlot: {
    legend: {
      position: { vertical: 'top', horizontal: 'right' },
    },
  },
  loader: {
    zIndex: (theme) => theme.zIndex.modal + 1,
    color: 'primary.white',
    backdropFilter: 'blur(2px)',
    transition: 'opacity 0.3s ease-in-out',
  },
};

export default styles;
